import SimpleSelect from '@components/V3/forms/SimpleSelect'

import {ReservationLabel} from '../../Label'
import {useCreateReservationContext} from '../../ReservationContext'

export default function ReservePartySize() {
  const {partySize, setPartySize, storeOptions} = useCreateReservationContext()
  return (
    <div>
      <ReservationLabel>Tamaño del grupo</ReservationLabel>
      <SimpleSelect
        options={storeOptions.availableTableSizes.map(size => ({
          label: size === 1 ? '1 persona' : `${size} personas`,
          value: `${size}`
        }))}
        value={`${partySize}`}
        onChange={(sizeString: string) => setPartySize(parseInt(sizeString))}
      />
    </div>
  )
}
